export { default as CollectionSort } from './collection-sort.component'
